export const userRegistrationURL = {
  local: 'https://gifs-wes-itg.ss-nonprod.cld.mutualofomaha.com/my-benefits/redirectToClaimsUi',
  itg: 'https://gifs-wes-itg.ss-nonprod.cld.mutualofomaha.com/my-benefits/redirectToClaimsUi',
  catInternal: 'https://gifs-wes-cat.ss-prod.cld.mutualofomaha.com/my-benefits/redirectToClaimsUi',
  catExternal: 'https://mybenefits20.mutualofomaha.com/my-benefits/redirectToClaimsUi',
  prodInternal: 'https://gifs-wes-prod.ss-prod.cld.mutualofomaha.com/my-benefits/redirectToClaimsUi',
  prodExternal: 'https://mybenefits.mutualofomaha.com/my-benefits/redirectToClaimsUi',
  // AWS
  // Story to refactor in future SPARTANS-680
  awsDev: 'https://gifs-wes-dev.ss-nonprod.cld.mutualofomaha.com/my-benefits/redirectToClaimsUi',
  awsItg: 'https://gifs-wes-itg.ss-nonprod.cld.mutualofomaha.com/my-benefits/redirectToClaimsUi',
  awsCat: 'https://gifs-wes-cat.ss-prod.cld.mutualofomaha.com/my-benefits/redirectToClaimsUi',
  awsProd: 'https://gifs-wes.ss-prod.cld.mutualofomaha.com/my-benefits/redirectToClaimsUi',

  // AWS SPOKE ACCOUNT URLs
  awsDevSpoke: 'https://gifs.wsm-employeemgmt-dev.cld.mutualofomaha.com/my-benefits/redirectToClaimsUi',
  awsItgSpoke: 'https://gifs.wsm-employeemgmt-itg.cld.mutualofomaha.com/my-benefits/redirectToClaimsUi',
  awsCatSpoke: 'https://gifs.wsm-employeemgmt-cat.cld.mutualofomaha.com/my-benefits/redirectToClaimsUi',
  awsProdSpoke: 'https://gifs.wsm-employeemgmt-prod.cld.mutualofomaha.com/my-benefits/redirectToClaimsUi',
};
export const LOCAL = 'local';
export const ITG = 'itg';
export const CAT_INTERNAL = 'catInternal';
export const CAT_EXTERNAL = 'catExternal';
export const PROD_INTERNAL = 'prodInternal';
export const PROD_EXTERNAL = 'prodExternal';
export const LOCAL_HOST = 'localhost';
export const ITG_HOST = 'gifs-wes-itg.ss-nonprod.cld.mutualofomaha.com';
export const INTERNAL_CAT_HOST = 'gifs-wes-cat.ss-prod.cld.mutualofomaha.com';
export const EXTERNAL_CAT_HOST = 'mybenefits20.mutualofomaha.com';
export const INTERNAL_PROD_HOST = 'gifs-wes.ss-prod.cld.mutualofomaha.com';
export const EXTERNAL_PROD_HOST = 'mybenefits.mutualofomaha.com';

export const DEV_SPOKE_HOST = 'gifs.wsm-employeemgmt-dev.cld.mutualofomaha.com';
export const DEV_SPOKE_VANITY_HOST = 'mybenefits-dev.mutualofomaha.com';
export const ITG_SPOKE_HOST = 'gifs.wsm-employeemgmt-itg.cld.mutualofomaha.com';
export const ITG_SPOKE_VANITY_HOST = 'mybenefits-itg.mutualofomaha.com';
export const CAT_SPOKE_HOST = 'gifs.wsm-employeemgmt-cat.cld.mutualofomaha.com';
export const CAT_SPOKE_VANITY_HOST = 'mybenefits-cat.mutualofomaha.com';
export const PROD_SPOKE_HOST = 'gifs.wsm-employeemgmt-prod.cld.mutualofomaha.com';

export const mutualOfOmahaHeaderLogo = 'https://cdn.mutualofomaha.com/images/corporate/logos/mutual-brand-blue.svg';

// AWS Environment variables
// Story to refactor in future SPARTANS-680
export const AWS_DEV = 'awsDev';
export const AWS_ITG = 'awsItg';
export const AWS_CAT = 'awsCat';
export const AWS_PROD = 'awsProd';

export const AWS_DEV_HOST = 'gifs-wes-dev.ss-nonprod.cld.mutualofomaha.com';
export const AWS_ITG_HOST = 'gifs-wes-itg.ss-nonprod.cld.mutualofomaha.com';
export const AWS_CAT_HOST = 'gifs-wes-cat.ss-prod.cld.mutualofomaha.com';
export const AWS_PROD_HOST = 'gifs-wes.ss-prod.cld.mutualofomaha.com';

export const AWS_DEV_SPOKE = 'awsDevSpoke';
export const AWS_ITG_SPOKE = 'awsItgSpoke';
export const AWS_CAT_SPOKE = 'awsCatSpoke';
export const AWS_PROD_SPOKE = 'awsProdSpoke';

export const googleAnalyticsUrls = {
  regApiResponseTime: 'regApiResponseTime',
  regSuccess: 'regSuccess',
  regFailed: 'regFailed',
  userExistEmail: 'userExistEmailSentToRegister',
  userExistPromptLogin: 'userExistPromptUserToLogin',

};
